import moment from 'moment';
/**
 * Given a tuple of a start and end date and a separate date determine if the date falls
 * between the start (inclusive) and end date (exclusive).
 *
 * @param start
 * @param end
 * @param date - defaults to the current time
 */
export default function withinDateRange([start, end], date = moment()) {
  return (date.isSame(start) || date.isAfter(start)) && date.isBefore(end);
}
